import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Divider} from '@daedalus/atlas/Divider'
import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'

const SKELETON_HEIGHT = 394
export const CARD_WIDTH = 230
export const CARD_IMAGE_HEIGHT = 153

const Wrapper = styled.div(
  ({theme}) => css`
    width: ${CARD_WIDTH}px;
    height: ${SKELETON_HEIGHT}px;
    background-color: ${theme.colors.background.neutral.c000};
    border: 1px solid ${theme.colors.border.neutral.c100};
    border-radius: ${theme.layout.radius.lg}px;
    cursor: pointer;
  `
)

const ImageWrapper = styled.div`
  width: 100%;
  height: ${CARD_IMAGE_HEIGHT}px;
  overflow: hidden;
`

const ContentContainer = styled.div(
  ({theme}) => css`
    padding: ${theme.layout.spacing.s300}px;
  `
)

const ReviewSection = styled.div(
  ({theme}) => css`
    display: flex;
    flex-direction: row;
    margin-top: ${theme.layout.spacing.s200}px;
  `
)

const ReviewDetailSection = styled.div(
  ({theme}) => css`
    margin-left: ${theme.layout.spacing.s250}px;
  `
)

const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

const PriceDetails = styled.div(
  ({theme}) => css`
    display: flex;
    & > div {
      margin-left: ${theme.layout.spacing.s100}px;
    }
  `
)

const StyledDivider = styled(Divider)(
  ({theme}) => css`
    margin: ${theme.layout.spacing.s400}px 0;
  `
)

const SkeletonButtonWrapper = styled.div(
  ({theme}) => css`
    margin: ${theme.layout.spacing.s400}px auto;
  `
)

export const PriceDetailsSkeleton = () => (
  <PriceDetails>
    <SkeletonLoader width={24} height={32} marginTop={2} />
    <SkeletonLoader width={42} height={32} marginTop={2} />
  </PriceDetails>
)

export const SuggestionHotelCardSkeleton = () => {
  return (
    <Wrapper>
      <ImageWrapper>
        <SkeletonLoader width={350} height={153} />
      </ImageWrapper>
      <ContentContainer>
        <div>
          <SkeletonLoader width={67} height={12} marginTop={8} />
          <SkeletonLoader width={100} height={24} marginTop={2} />
          <SkeletonLoader width={67} height={16} marginTop={2} />
        </div>
        <ReviewSection>
          <SkeletonLoader width={32} height={32} />
          <ReviewDetailSection>
            <SkeletonLoader width={55} height={16} />
            <SkeletonLoader width={79} height={14} />
          </ReviewDetailSection>
        </ReviewSection>

        <StyledDivider />

        <SkeletonLoader width={100} height={16} marginTop={12} />

        <PriceSection>
          <PriceDetailsSkeleton />
        </PriceSection>

        <SkeletonButtonWrapper>
          <SkeletonLoader width={214} height={34} />
        </SkeletonButtonWrapper>
      </ContentContainer>
    </Wrapper>
  )
}
